(function () {
  // Rulează doar pe market-ul EU (engleză)
  var isEn = window.location.pathname.indexOf('/en-eu') === 0;
  if (!isEn) return;

  // ==========================
  // DICȚIONAR
  // Cheile din stânga = textul original românesc (din data-label / conținut)
  // ==========================
  var LABELS = {
    'Nume': 'Name',
    'Nume cafenea/companie': 'Café / company name',
    'Email': 'Email',
    'Parolă': 'Password',
    'Confirmă parola': 'Confirm password',
    'Volum estimativ de cafea utilizat lunar (kg)': 'Estimated monthly coffee volume (kg)',
    'Informații suplimentare despre companie': 'Additional company information'
  };

  var TEXTS = {
    'Cerere Parteneriat B2B': 'B2B Partnership Request',
    'Completează datele de mai jos, iar echipa MABÓ te va contacta pentru a discuta oportunitățile de colaborare.':
      'Fill in the details below and the MABÓ team will get in touch to discuss collaboration opportunities.',
    'Descrieți pe scurt tipul de activitate, locația, volumul estimativ și obiectivele colaborării.':
      'Briefly describe your business type, location, estimated volume and collaboration goals.',
    'Submit': 'Submit',
    // Mesaj de succes
    'Mulțumim că ne-ai contactat!': 'Thank you for reaching out!',
    'Apreciem că ai luat legătura cu noi. Unul dintre colegii noștri îți va răspunde în curând!':
      'We appreciate you contacting us. One of our colleagues will get back to you shortly!',
    'O zi frumoasă!': 'Have a great day!'
  };

  // ==========================
  // TRADUCERE
  // ==========================
  function translate(root) {
    // 1. Label-uri prin data-label (metoda robustă)
    root.querySelectorAll('.samitaWS-label .label-content[data-label]').forEach(function (el) {
      var key = el.getAttribute('data-label');
      if (LABELS[key] && el.textContent.trim() !== LABELS[key]) {
        el.textContent = LABELS[key];
      }
    });

    // 2. Titlu formular
    root.querySelectorAll('.samitaWS-heading').forEach(function (el) {
      var key = el.textContent.trim();
      if (TEXTS[key]) el.textContent = TEXTS[key];
    });

    // 3. Descriere + orice paragraf/heading din mesajele de succes
    root.querySelectorAll('.samitaWS-description p, .message.success h4, .message.success p').forEach(function (el) {
      var key = el.textContent.trim().replace(/\u00a0/g, '').trim(); // scoate &nbsp;
      if (TEXTS[key]) el.textContent = TEXTS[key];
    });

    // 4. Buton submit (păstrează structura cu spinner-ul dinăuntru)
    root.querySelectorAll('button.submit').forEach(function (btn) {
      // butonul conține <span class="spinner"></span> + text
      btn.childNodes.forEach(function (node) {
        if (node.nodeType === 3 && node.textContent.trim() === 'Submit') {
          node.textContent = ' ' + TEXTS['Submit'] + ' ';
        }
      });
    });

    // 5. Placeholder-e
    root.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function (el) {
      var key = el.getAttribute('placeholder').trim();
      if (key && TEXTS[key]) el.setAttribute('placeholder', TEXTS[key]);
    });
  }

  // ==========================
  // INIT + OBSERVER
  // Sami randează formularul async, deci trebuie să prindem și mutațiile
  // ==========================
  function boot() {
    translate(document);

    var observer = new MutationObserver(function (mutations) {
      // re-traduce doar dacă apare conținut nou relevant
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          translate(document);
          break;
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();